module.exports = __webpack_public_path__ + "static/servers-5ef1c94f7ed4c63bc6f597de3caf3c67.png";